import { gql, NetworkStatus, useQuery } from "@apollo/client";
import { shiftStreamClient } from "../../../graphql/client";

export const PAGE_SIZE = 50;

export const GET_AUDIT_LOGS = gql`
  query getAuditLogs($offset: Int!, $limit: Int!, $action: String) {
    auditLogs(offset: $offset, limit: $limit, action: $action) {
      total

      data {
        id
        userId
        userEmail
        userName
        action
        resourceId
        args
        isError
        message
        createdAt
      }
    }
  }
`;

export const useAuditLogs = (page = 1, action?: string) => {
  const safePage = Math.max(1, page);
  const offset = (safePage - 1) * PAGE_SIZE;

  const { data, previousData, loading, networkStatus, refetch } = useQuery(
    GET_AUDIT_LOGS,
    {
      client: shiftStreamClient,
      variables: {
        offset,
        limit: PAGE_SIZE,
        action: action || undefined
      },
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
      onError: (error: any) => {
        throw error;
      }
    }
  );

  const resolvedData = data || previousData;

  const total = resolvedData?.auditLogs?.total || 0;
  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  return {
    loading: loading || networkStatus === NetworkStatus.refetch,
    auditLogs: resolvedData?.auditLogs?.data || [],
    total,
    totalPages,
    page: safePage,
    refetch
  };
};
